import { render, staticRenderFns } from "./BailiffsList.vue?vue&type=template&id=914405ba&"
import script from "./BailiffsList.vue?vue&type=script&lang=js&"
export * from "./BailiffsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports